import axios from 'axios';
import { Env } from '@/configuration';
import { SiteForDisplay } from './models';

const fetchSites = async () => {
  const sitesUrl = Env.CoreApiOptions.endpointUrl(`sites/forDisplay`);
  const response = await axios.get(sitesUrl);
  const result: SiteForDisplay[] = response && response.data;
  return result;
};

export default {
  fetchSites,
};
